import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import * as T_T from 'cryface';
import { CommonConfig } from '../../configs/config.common';
import ASpaceInBetweenAnother from '../ASpaceInBetweenAnother/a.space.inbetween.another.vue';

@Component({
   components: {
      ASpaceInBetweenAnother
   }
})
export default class JustSoldCard extends Vue {
   public title: string = 'JustSoldCard';

   public comonConfig = new CommonConfig();

   @Prop()
   public data: any;

   public displayData: any = {};

   @Watch('data', { immediate: true, deep: true })
   public onDataInput(val: any, oldVal: any) {
      val.soldDesc = this.soldDesc(val.price, val.soldPrice, val.soldInDays);
      this.displayData = val;
   }

   public soldDesc(price: number, soldPrice: number, soldInDays: any) {
      if (soldPrice > price) {
         return 'Sold Over Asking';
      }
      if (T_T.simpleDetect(soldInDays)) {
         if (Number(soldInDays) < this.comonConfig.soldInXDays) {
            return `Sold In Just ${soldInDays} Days`;
         }
      }
      return 'Sold';
   }

   public navToDetail(mlsNumber: string) {
      // this.$router.push(`/listing/treb-${mlsNumber}`);
   }
}
